import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

class ngFoot extends ngElement
{
	#owner;
	
	constructor () {
		super();
		this.applyBaseStyle();
	}
	
	connectedCallback() {
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");
		
		this.shadowRoot.innerHTML = `
			<ng-layout></ng-layout>
			<ng-paging></ng-paging>
		`;

		super.connectedCallback();
	};
}

class ngLayout extends HTMLElement
{
	#owner;
	#tables;
	#wrap;
	#at;
	
	constructor () {
		super();
		
		this.#tables = [];
		this.#at = 0;
	}
	
	connectedCallback() {
		this.#owner = this.getRootNode().host.getRootNode().host;//this.closest("nine-grid");

		this.innerHTML =`<div class="ng-wrap"></div>`;
		this.#wrap = this.querySelector(".ng-wrap");
	};
	
	add = (arr) => {
		
		this.#tables.push(...arr);
		
		var i = 0;
		for (const tbl of this.#tables) {
			i++;
			const caption = tbl.querySelector("caption");
			const sheetName = caption ? caption.innerHTML : `Sheet${i}`;
			
			$(this.#wrap).append(`<button class="ng-button" value="${i-1}" title="${sheetName.replaceAll('"', "'")}">${sheetName}</button>`);
		}
		
		if (this.#tables.length <= 1) $(this.#wrap).hide();

		//$("button", this.#wrap).eq(0).addClass("ng-active");
		ninegrid.j.querySelectorAll(this.#wrap.querySelector("button")).addClass("ng-active");
		
		$("button", this.#wrap).on("click", this.#onClick);
	};
	
	get tables() {
		return this.#tables;
	};
	get currentTable() {
		return this.#tables[this.#at];
	};
	
	resize = () => {
		const overflow = $(this.#wrap).width() > $(this).width();

		$(this.#wrap).css({
			"width": overflow ? "100%" : "unset",
			"justify-content": overflow ? "space-evenly" : "unset",
		});
	};
	
	#onClick = e => {
		
		if (ninegrid.j.querySelectorAll(e.currentTarget).hasClass("ng-active")) return;
		
		const oldIndex = this.#at;
		
		this.#at = parseInt(e.currentTarget.value);
		
		this.#owner.changeRayout(this.#at);
		
		ninegrid.j.querySelectorAll("button", this.#wrap).removeClass("ng-active");
		ninegrid.j.querySelectorAll(e.currentTarget).addClass("ng-active");
		
		var customEvent = new CustomEvent(ninegrid.EVENT.LAYOUT_CHANGED, { bubbles: true, detail: {} });
		customEvent.oldIndex	= oldIndex;
		customEvent.newIndex	= this.#at;
		
		this.#owner.dispatchEvent(customEvent);
	};
}

if (!customElements.get('ng-layout')) {
	customElements.define("ng-layout", ngLayout);
}

if (!customElements.get('ng-foot')) {
	customElements.define("ng-foot", ngFoot);
}
